module.exports = __webpack_public_path__ + "static/media/chuttapp.402ef222.png";